import { render, staticRenderFns } from "./repositoryCheckList.vue?vue&type=template&id=00108f6b&scoped=true"
import script from "./repositoryCheckList.vue?vue&type=script&lang=js"
export * from "./repositoryCheckList.vue?vue&type=script&lang=js"
import style0 from "./repositoryCheckList.vue?vue&type=style&index=0&id=00108f6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00108f6b",
  null
  
)

export default component.exports